
export function setCookies (state, bearer) {
  state.cookies = true
}
